import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../services/AIInspectionManagerService';
export default function useAIInspectionManager() {
    return useQuery(['aiInspectionManagerSettings'], () => getSettings(), {
        staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
        cacheTime: 30 * 60 * 1000 // Keep unused data in cache for 30 minutes
    });
}
